/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as ProfileImport } from './routes/_profile'
import { Route as MainImport } from './routes/_main'
import { Route as DocsImport } from './routes/_docs'
import { Route as IndexImport } from './routes/index'
import { Route as PublicHomeImport } from './routes/_public/home'
import { Route as MainAppIndexImport } from './routes/_main/app/index'
import { Route as ProfileProfileUpdateUsernameImport } from './routes/_profile/profile/update-username'
import { Route as ProfileProfileUpdatePasswordImport } from './routes/_profile/profile/update-password'
import { Route as ProfileProfileUpdateEmailImport } from './routes/_profile/profile/update-email'
import { Route as MainAppVerificationCodesIndexImport } from './routes/_main/app/verification-codes.index'
import { Route as MainAppUsersIndexImport } from './routes/_main/app/users.index'
import { Route as MainAppPosIndexImport } from './routes/_main/app/pos.index'
import { Route as MainAppMessagesIndexImport } from './routes/_main/app/messages.index'
import { Route as MainAppCatalogsIndexImport } from './routes/_main/app/catalogs.index'
import { Route as MainAppAudiologistsIndexImport } from './routes/_main/app/audiologists.index'
import { Route as MainAppApiTokenIndexImport } from './routes/_main/app/api-token.index'
import { Route as MainAppCatalogsCreateImport } from './routes/_main/app/catalogs.create'
import { Route as MainAppCatalogsCatalogCatalogIdIndexImport } from './routes/_main/app/catalogs.catalog.$catalogId.index'

// Create Virtual Routes

const PublicTermsOfService2026LazyImport = createFileRoute(
  '/_public/terms-of-service2026',
)()
const PublicTermsOfServiceLazyImport = createFileRoute(
  '/_public/terms-of-service',
)()
const PublicRegistrationSuccessLazyImport = createFileRoute(
  '/_public/registration-success',
)()
const PublicRegistrationLazyImport = createFileRoute('/_public/registration')()
const PublicImprintLazyImport = createFileRoute('/_public/imprint')()
const PublicDataProtectionLazyImport = createFileRoute(
  '/_public/data-protection',
)()
const ProfileProfileIndexLazyImport = createFileRoute('/_profile/profile/')()
const DocsDocsIndexLazyImport = createFileRoute('/_docs/docs/')()
const ProfileProfileDetailsLazyImport = createFileRoute(
  '/_profile/profile/details',
)()
const MainAppVerificationCodesLazyImport = createFileRoute(
  '/_main/app/verification-codes',
)()
const MainAppUsersLazyImport = createFileRoute('/_main/app/users')()
const MainAppSettingsLazyImport = createFileRoute('/_main/app/settings')()
const MainAppPosLazyImport = createFileRoute('/_main/app/pos')()
const MainAppMessagesLazyImport = createFileRoute('/_main/app/messages')()
const MainAppDashboardLazyImport = createFileRoute('/_main/app/dashboard')()
const MainAppCustomersLazyImport = createFileRoute('/_main/app/customers')()
const MainAppCatalogsLazyImport = createFileRoute('/_main/app/catalogs')()
const MainAppAudiologistsLazyImport = createFileRoute(
  '/_main/app/audiologists',
)()
const MainAppApiTokenLazyImport = createFileRoute('/_main/app/api-token')()
const MainAppCustomersIndexLazyImport = createFileRoute(
  '/_main/app/customers/',
)()
const MainAppVerificationCodesCreateLazyImport = createFileRoute(
  '/_main/app/verification-codes/create',
)()
const MainAppVerificationCodesVerificationCodeIdLazyImport = createFileRoute(
  '/_main/app/verification-codes/$verificationCodeId',
)()
const MainAppUsersCreateLazyImport = createFileRoute(
  '/_main/app/users/create',
)()
const MainAppUsersUserIdLazyImport = createFileRoute(
  '/_main/app/users/$userId',
)()
const MainAppPosCreateLazyImport = createFileRoute('/_main/app/pos/create')()
const MainAppPosPosIdLazyImport = createFileRoute('/_main/app/pos/$posId')()
const MainAppMessagesMessageIdLazyImport = createFileRoute(
  '/_main/app/messages/$messageId',
)()
const MainAppAudiologistsAudiologistIdLazyImport = createFileRoute(
  '/_main/app/audiologists/$audiologistId',
)()
const MainAppApiTokenCreateLazyImport = createFileRoute(
  '/_main/app/api-token/create',
)()
const DocsDocsApiPublicChangelogLazyImport = createFileRoute(
  '/_docs/docs/api/public-changelog',
)()
const DocsDocsApiPublicLazyImport = createFileRoute('/_docs/docs/api/public')()
const DocsDocsApiMockChangelogLazyImport = createFileRoute(
  '/_docs/docs/api/mock-changelog',
)()
const DocsDocsApiMockLazyImport = createFileRoute('/_docs/docs/api/mock')()
const MainAppCatalogsCatalogCatalogIdLazyImport = createFileRoute(
  '/_main/app/catalogs/catalog/$catalogId',
)()
const MainAppCatalogsCatalogCatalogIdVersionLazyImport = createFileRoute(
  '/_main/app/catalogs/catalog/$catalogId/version',
)()
const MainAppCatalogsCatalogCatalogIdRulesLazyImport = createFileRoute(
  '/_main/app/catalogs/catalog/$catalogId/rules',
)()
const MainAppCatalogsCatalogCatalogIdCreateLazyImport = createFileRoute(
  '/_main/app/catalogs/catalog/$catalogId/create',
)()
const MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyImport =
  createFileRoute(
    '/_main/app/catalogs/catalog/$catalogId/version/$catalogVersionId',
  )()

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const ProfileRoute = ProfileImport.update({
  id: '/_profile',
  getParentRoute: () => rootRoute,
} as any)

const MainRoute = MainImport.update({
  id: '/_main',
  getParentRoute: () => rootRoute,
} as any)

const DocsRoute = DocsImport.update({
  id: '/_docs',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PublicTermsOfService2026LazyRoute =
  PublicTermsOfService2026LazyImport.update({
    id: '/terms-of-service2026',
    path: '/terms-of-service2026',
    getParentRoute: () => PublicRoute,
  } as any).lazy(() =>
    import('./routes/_public/terms-of-service2026.lazy').then((d) => d.Route),
  )

const PublicTermsOfServiceLazyRoute = PublicTermsOfServiceLazyImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public/terms-of-service.lazy').then((d) => d.Route),
)

const PublicRegistrationSuccessLazyRoute =
  PublicRegistrationSuccessLazyImport.update({
    id: '/registration-success',
    path: '/registration-success',
    getParentRoute: () => PublicRoute,
  } as any).lazy(() =>
    import('./routes/_public/registration-success.lazy').then((d) => d.Route),
  )

const PublicRegistrationLazyRoute = PublicRegistrationLazyImport.update({
  id: '/registration',
  path: '/registration',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public/registration.lazy').then((d) => d.Route),
)

const PublicImprintLazyRoute = PublicImprintLazyImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public/imprint.lazy').then((d) => d.Route),
)

const PublicDataProtectionLazyRoute = PublicDataProtectionLazyImport.update({
  id: '/data-protection',
  path: '/data-protection',
  getParentRoute: () => PublicRoute,
} as any).lazy(() =>
  import('./routes/_public/data-protection.lazy').then((d) => d.Route),
)

const PublicHomeRoute = PublicHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => PublicRoute,
} as any)

const ProfileProfileIndexLazyRoute = ProfileProfileIndexLazyImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => ProfileRoute,
} as any).lazy(() =>
  import('./routes/_profile/profile/index.lazy').then((d) => d.Route),
)

const DocsDocsIndexLazyRoute = DocsDocsIndexLazyImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => DocsRoute,
} as any).lazy(() =>
  import('./routes/_docs/docs/index.lazy').then((d) => d.Route),
)

const MainAppIndexRoute = MainAppIndexImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => MainRoute,
} as any)

const ProfileProfileDetailsLazyRoute = ProfileProfileDetailsLazyImport.update({
  id: '/profile/details',
  path: '/profile/details',
  getParentRoute: () => ProfileRoute,
} as any).lazy(() =>
  import('./routes/_profile/profile/details.lazy').then((d) => d.Route),
)

const MainAppVerificationCodesLazyRoute =
  MainAppVerificationCodesLazyImport.update({
    id: '/app/verification-codes',
    path: '/app/verification-codes',
    getParentRoute: () => MainRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/verification-codes.lazy').then((d) => d.Route),
  )

const MainAppUsersLazyRoute = MainAppUsersLazyImport.update({
  id: '/app/users',
  path: '/app/users',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/users.lazy').then((d) => d.Route),
)

const MainAppSettingsLazyRoute = MainAppSettingsLazyImport.update({
  id: '/app/settings',
  path: '/app/settings',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/settings.lazy').then((d) => d.Route),
)

const MainAppPosLazyRoute = MainAppPosLazyImport.update({
  id: '/app/pos',
  path: '/app/pos',
  getParentRoute: () => MainRoute,
} as any).lazy(() => import('./routes/_main/app/pos.lazy').then((d) => d.Route))

const MainAppMessagesLazyRoute = MainAppMessagesLazyImport.update({
  id: '/app/messages',
  path: '/app/messages',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/messages.lazy').then((d) => d.Route),
)

const MainAppDashboardLazyRoute = MainAppDashboardLazyImport.update({
  id: '/app/dashboard',
  path: '/app/dashboard',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/dashboard.lazy').then((d) => d.Route),
)

const MainAppCustomersLazyRoute = MainAppCustomersLazyImport.update({
  id: '/app/customers',
  path: '/app/customers',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/customers.lazy').then((d) => d.Route),
)

const MainAppCatalogsLazyRoute = MainAppCatalogsLazyImport.update({
  id: '/app/catalogs',
  path: '/app/catalogs',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/catalogs.lazy').then((d) => d.Route),
)

const MainAppAudiologistsLazyRoute = MainAppAudiologistsLazyImport.update({
  id: '/app/audiologists',
  path: '/app/audiologists',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/audiologists.lazy').then((d) => d.Route),
)

const MainAppApiTokenLazyRoute = MainAppApiTokenLazyImport.update({
  id: '/app/api-token',
  path: '/app/api-token',
  getParentRoute: () => MainRoute,
} as any).lazy(() =>
  import('./routes/_main/app/api-token.lazy').then((d) => d.Route),
)

const ProfileProfileUpdateUsernameRoute =
  ProfileProfileUpdateUsernameImport.update({
    id: '/profile/update-username',
    path: '/profile/update-username',
    getParentRoute: () => ProfileRoute,
  } as any)

const ProfileProfileUpdatePasswordRoute =
  ProfileProfileUpdatePasswordImport.update({
    id: '/profile/update-password',
    path: '/profile/update-password',
    getParentRoute: () => ProfileRoute,
  } as any)

const ProfileProfileUpdateEmailRoute = ProfileProfileUpdateEmailImport.update({
  id: '/profile/update-email',
  path: '/profile/update-email',
  getParentRoute: () => ProfileRoute,
} as any)

const MainAppCustomersIndexLazyRoute = MainAppCustomersIndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAppCustomersLazyRoute,
} as any).lazy(() =>
  import('./routes/_main/app/customers.index.lazy').then((d) => d.Route),
)

const MainAppVerificationCodesIndexRoute =
  MainAppVerificationCodesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MainAppVerificationCodesLazyRoute,
  } as any)

const MainAppUsersIndexRoute = MainAppUsersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAppUsersLazyRoute,
} as any)

const MainAppPosIndexRoute = MainAppPosIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAppPosLazyRoute,
} as any)

const MainAppMessagesIndexRoute = MainAppMessagesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAppMessagesLazyRoute,
} as any)

const MainAppCatalogsIndexRoute = MainAppCatalogsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAppCatalogsLazyRoute,
} as any)

const MainAppAudiologistsIndexRoute = MainAppAudiologistsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAppAudiologistsLazyRoute,
} as any)

const MainAppApiTokenIndexRoute = MainAppApiTokenIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MainAppApiTokenLazyRoute,
} as any)

const MainAppVerificationCodesCreateLazyRoute =
  MainAppVerificationCodesCreateLazyImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => MainAppVerificationCodesLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/verification-codes.create.lazy').then(
      (d) => d.Route,
    ),
  )

const MainAppVerificationCodesVerificationCodeIdLazyRoute =
  MainAppVerificationCodesVerificationCodeIdLazyImport.update({
    id: '/$verificationCodeId',
    path: '/$verificationCodeId',
    getParentRoute: () => MainAppVerificationCodesLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_main/app/verification-codes.$verificationCodeId.lazy'
    ).then((d) => d.Route),
  )

const MainAppUsersCreateLazyRoute = MainAppUsersCreateLazyImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => MainAppUsersLazyRoute,
} as any).lazy(() =>
  import('./routes/_main/app/users.create.lazy').then((d) => d.Route),
)

const MainAppUsersUserIdLazyRoute = MainAppUsersUserIdLazyImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => MainAppUsersLazyRoute,
} as any).lazy(() =>
  import('./routes/_main/app/users.$userId.lazy').then((d) => d.Route),
)

const MainAppPosCreateLazyRoute = MainAppPosCreateLazyImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => MainAppPosLazyRoute,
} as any).lazy(() =>
  import('./routes/_main/app/pos.create.lazy').then((d) => d.Route),
)

const MainAppPosPosIdLazyRoute = MainAppPosPosIdLazyImport.update({
  id: '/$posId',
  path: '/$posId',
  getParentRoute: () => MainAppPosLazyRoute,
} as any).lazy(() =>
  import('./routes/_main/app/pos.$posId.lazy').then((d) => d.Route),
)

const MainAppMessagesMessageIdLazyRoute =
  MainAppMessagesMessageIdLazyImport.update({
    id: '/$messageId',
    path: '/$messageId',
    getParentRoute: () => MainAppMessagesLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/messages.$messageId.lazy').then((d) => d.Route),
  )

const MainAppAudiologistsAudiologistIdLazyRoute =
  MainAppAudiologistsAudiologistIdLazyImport.update({
    id: '/$audiologistId',
    path: '/$audiologistId',
    getParentRoute: () => MainAppAudiologistsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/audiologists.$audiologistId.lazy').then(
      (d) => d.Route,
    ),
  )

const MainAppApiTokenCreateLazyRoute = MainAppApiTokenCreateLazyImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => MainAppApiTokenLazyRoute,
} as any).lazy(() =>
  import('./routes/_main/app/api-token.create.lazy').then((d) => d.Route),
)

const DocsDocsApiPublicChangelogLazyRoute =
  DocsDocsApiPublicChangelogLazyImport.update({
    id: '/docs/api/public-changelog',
    path: '/docs/api/public-changelog',
    getParentRoute: () => DocsRoute,
  } as any).lazy(() =>
    import('./routes/_docs/docs/api.public-changelog.lazy').then(
      (d) => d.Route,
    ),
  )

const DocsDocsApiPublicLazyRoute = DocsDocsApiPublicLazyImport.update({
  id: '/docs/api/public',
  path: '/docs/api/public',
  getParentRoute: () => DocsRoute,
} as any).lazy(() =>
  import('./routes/_docs/docs/api.public.lazy').then((d) => d.Route),
)

const DocsDocsApiMockChangelogLazyRoute =
  DocsDocsApiMockChangelogLazyImport.update({
    id: '/docs/api/mock-changelog',
    path: '/docs/api/mock-changelog',
    getParentRoute: () => DocsRoute,
  } as any).lazy(() =>
    import('./routes/_docs/docs/api.mock-changelog.lazy').then((d) => d.Route),
  )

const DocsDocsApiMockLazyRoute = DocsDocsApiMockLazyImport.update({
  id: '/docs/api/mock',
  path: '/docs/api/mock',
  getParentRoute: () => DocsRoute,
} as any).lazy(() =>
  import('./routes/_docs/docs/api.mock.lazy').then((d) => d.Route),
)

const MainAppCatalogsCreateRoute = MainAppCatalogsCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => MainAppCatalogsLazyRoute,
} as any)

const MainAppCatalogsCatalogCatalogIdLazyRoute =
  MainAppCatalogsCatalogCatalogIdLazyImport.update({
    id: '/catalog/$catalogId',
    path: '/catalog/$catalogId',
    getParentRoute: () => MainAppCatalogsLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/catalogs.catalog.$catalogId.lazy').then(
      (d) => d.Route,
    ),
  )

const MainAppCatalogsCatalogCatalogIdIndexRoute =
  MainAppCatalogsCatalogCatalogIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MainAppCatalogsCatalogCatalogIdLazyRoute,
  } as any)

const MainAppCatalogsCatalogCatalogIdVersionLazyRoute =
  MainAppCatalogsCatalogCatalogIdVersionLazyImport.update({
    id: '/version',
    path: '/version',
    getParentRoute: () => MainAppCatalogsCatalogCatalogIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/catalogs.catalog.$catalogId.version.lazy').then(
      (d) => d.Route,
    ),
  )

const MainAppCatalogsCatalogCatalogIdRulesLazyRoute =
  MainAppCatalogsCatalogCatalogIdRulesLazyImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => MainAppCatalogsCatalogCatalogIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/catalogs.catalog.$catalogId.rules.lazy').then(
      (d) => d.Route,
    ),
  )

const MainAppCatalogsCatalogCatalogIdCreateLazyRoute =
  MainAppCatalogsCatalogCatalogIdCreateLazyImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => MainAppCatalogsCatalogCatalogIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_main/app/catalogs.catalog.$catalogId.create.lazy').then(
      (d) => d.Route,
    ),
  )

const MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute =
  MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyImport.update({
    id: '/$catalogVersionId',
    path: '/$catalogVersionId',
    getParentRoute: () => MainAppCatalogsCatalogCatalogIdVersionLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_main/app/catalogs.catalog.$catalogId.version.$catalogVersionId.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_docs': {
      id: '/_docs'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DocsImport
      parentRoute: typeof rootRoute
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainImport
      parentRoute: typeof rootRoute
    }
    '/_profile': {
      id: '/_profile'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProfileImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/_public/home': {
      id: '/_public/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof PublicHomeImport
      parentRoute: typeof PublicImport
    }
    '/_public/data-protection': {
      id: '/_public/data-protection'
      path: '/data-protection'
      fullPath: '/data-protection'
      preLoaderRoute: typeof PublicDataProtectionLazyImport
      parentRoute: typeof PublicImport
    }
    '/_public/imprint': {
      id: '/_public/imprint'
      path: '/imprint'
      fullPath: '/imprint'
      preLoaderRoute: typeof PublicImprintLazyImport
      parentRoute: typeof PublicImport
    }
    '/_public/registration': {
      id: '/_public/registration'
      path: '/registration'
      fullPath: '/registration'
      preLoaderRoute: typeof PublicRegistrationLazyImport
      parentRoute: typeof PublicImport
    }
    '/_public/registration-success': {
      id: '/_public/registration-success'
      path: '/registration-success'
      fullPath: '/registration-success'
      preLoaderRoute: typeof PublicRegistrationSuccessLazyImport
      parentRoute: typeof PublicImport
    }
    '/_public/terms-of-service': {
      id: '/_public/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof PublicTermsOfServiceLazyImport
      parentRoute: typeof PublicImport
    }
    '/_public/terms-of-service2026': {
      id: '/_public/terms-of-service2026'
      path: '/terms-of-service2026'
      fullPath: '/terms-of-service2026'
      preLoaderRoute: typeof PublicTermsOfService2026LazyImport
      parentRoute: typeof PublicImport
    }
    '/_profile/profile/update-email': {
      id: '/_profile/profile/update-email'
      path: '/profile/update-email'
      fullPath: '/profile/update-email'
      preLoaderRoute: typeof ProfileProfileUpdateEmailImport
      parentRoute: typeof ProfileImport
    }
    '/_profile/profile/update-password': {
      id: '/_profile/profile/update-password'
      path: '/profile/update-password'
      fullPath: '/profile/update-password'
      preLoaderRoute: typeof ProfileProfileUpdatePasswordImport
      parentRoute: typeof ProfileImport
    }
    '/_profile/profile/update-username': {
      id: '/_profile/profile/update-username'
      path: '/profile/update-username'
      fullPath: '/profile/update-username'
      preLoaderRoute: typeof ProfileProfileUpdateUsernameImport
      parentRoute: typeof ProfileImport
    }
    '/_main/app/api-token': {
      id: '/_main/app/api-token'
      path: '/app/api-token'
      fullPath: '/app/api-token'
      preLoaderRoute: typeof MainAppApiTokenLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/audiologists': {
      id: '/_main/app/audiologists'
      path: '/app/audiologists'
      fullPath: '/app/audiologists'
      preLoaderRoute: typeof MainAppAudiologistsLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/catalogs': {
      id: '/_main/app/catalogs'
      path: '/app/catalogs'
      fullPath: '/app/catalogs'
      preLoaderRoute: typeof MainAppCatalogsLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/customers': {
      id: '/_main/app/customers'
      path: '/app/customers'
      fullPath: '/app/customers'
      preLoaderRoute: typeof MainAppCustomersLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/dashboard': {
      id: '/_main/app/dashboard'
      path: '/app/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof MainAppDashboardLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/messages': {
      id: '/_main/app/messages'
      path: '/app/messages'
      fullPath: '/app/messages'
      preLoaderRoute: typeof MainAppMessagesLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/pos': {
      id: '/_main/app/pos'
      path: '/app/pos'
      fullPath: '/app/pos'
      preLoaderRoute: typeof MainAppPosLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/settings': {
      id: '/_main/app/settings'
      path: '/app/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof MainAppSettingsLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/users': {
      id: '/_main/app/users'
      path: '/app/users'
      fullPath: '/app/users'
      preLoaderRoute: typeof MainAppUsersLazyImport
      parentRoute: typeof MainImport
    }
    '/_main/app/verification-codes': {
      id: '/_main/app/verification-codes'
      path: '/app/verification-codes'
      fullPath: '/app/verification-codes'
      preLoaderRoute: typeof MainAppVerificationCodesLazyImport
      parentRoute: typeof MainImport
    }
    '/_profile/profile/details': {
      id: '/_profile/profile/details'
      path: '/profile/details'
      fullPath: '/profile/details'
      preLoaderRoute: typeof ProfileProfileDetailsLazyImport
      parentRoute: typeof ProfileImport
    }
    '/_main/app/': {
      id: '/_main/app/'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof MainAppIndexImport
      parentRoute: typeof MainImport
    }
    '/_docs/docs/': {
      id: '/_docs/docs/'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsDocsIndexLazyImport
      parentRoute: typeof DocsImport
    }
    '/_profile/profile/': {
      id: '/_profile/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileProfileIndexLazyImport
      parentRoute: typeof ProfileImport
    }
    '/_main/app/catalogs/create': {
      id: '/_main/app/catalogs/create'
      path: '/create'
      fullPath: '/app/catalogs/create'
      preLoaderRoute: typeof MainAppCatalogsCreateImport
      parentRoute: typeof MainAppCatalogsLazyImport
    }
    '/_docs/docs/api/mock': {
      id: '/_docs/docs/api/mock'
      path: '/docs/api/mock'
      fullPath: '/docs/api/mock'
      preLoaderRoute: typeof DocsDocsApiMockLazyImport
      parentRoute: typeof DocsImport
    }
    '/_docs/docs/api/mock-changelog': {
      id: '/_docs/docs/api/mock-changelog'
      path: '/docs/api/mock-changelog'
      fullPath: '/docs/api/mock-changelog'
      preLoaderRoute: typeof DocsDocsApiMockChangelogLazyImport
      parentRoute: typeof DocsImport
    }
    '/_docs/docs/api/public': {
      id: '/_docs/docs/api/public'
      path: '/docs/api/public'
      fullPath: '/docs/api/public'
      preLoaderRoute: typeof DocsDocsApiPublicLazyImport
      parentRoute: typeof DocsImport
    }
    '/_docs/docs/api/public-changelog': {
      id: '/_docs/docs/api/public-changelog'
      path: '/docs/api/public-changelog'
      fullPath: '/docs/api/public-changelog'
      preLoaderRoute: typeof DocsDocsApiPublicChangelogLazyImport
      parentRoute: typeof DocsImport
    }
    '/_main/app/api-token/create': {
      id: '/_main/app/api-token/create'
      path: '/create'
      fullPath: '/app/api-token/create'
      preLoaderRoute: typeof MainAppApiTokenCreateLazyImport
      parentRoute: typeof MainAppApiTokenLazyImport
    }
    '/_main/app/audiologists/$audiologistId': {
      id: '/_main/app/audiologists/$audiologistId'
      path: '/$audiologistId'
      fullPath: '/app/audiologists/$audiologistId'
      preLoaderRoute: typeof MainAppAudiologistsAudiologistIdLazyImport
      parentRoute: typeof MainAppAudiologistsLazyImport
    }
    '/_main/app/messages/$messageId': {
      id: '/_main/app/messages/$messageId'
      path: '/$messageId'
      fullPath: '/app/messages/$messageId'
      preLoaderRoute: typeof MainAppMessagesMessageIdLazyImport
      parentRoute: typeof MainAppMessagesLazyImport
    }
    '/_main/app/pos/$posId': {
      id: '/_main/app/pos/$posId'
      path: '/$posId'
      fullPath: '/app/pos/$posId'
      preLoaderRoute: typeof MainAppPosPosIdLazyImport
      parentRoute: typeof MainAppPosLazyImport
    }
    '/_main/app/pos/create': {
      id: '/_main/app/pos/create'
      path: '/create'
      fullPath: '/app/pos/create'
      preLoaderRoute: typeof MainAppPosCreateLazyImport
      parentRoute: typeof MainAppPosLazyImport
    }
    '/_main/app/users/$userId': {
      id: '/_main/app/users/$userId'
      path: '/$userId'
      fullPath: '/app/users/$userId'
      preLoaderRoute: typeof MainAppUsersUserIdLazyImport
      parentRoute: typeof MainAppUsersLazyImport
    }
    '/_main/app/users/create': {
      id: '/_main/app/users/create'
      path: '/create'
      fullPath: '/app/users/create'
      preLoaderRoute: typeof MainAppUsersCreateLazyImport
      parentRoute: typeof MainAppUsersLazyImport
    }
    '/_main/app/verification-codes/$verificationCodeId': {
      id: '/_main/app/verification-codes/$verificationCodeId'
      path: '/$verificationCodeId'
      fullPath: '/app/verification-codes/$verificationCodeId'
      preLoaderRoute: typeof MainAppVerificationCodesVerificationCodeIdLazyImport
      parentRoute: typeof MainAppVerificationCodesLazyImport
    }
    '/_main/app/verification-codes/create': {
      id: '/_main/app/verification-codes/create'
      path: '/create'
      fullPath: '/app/verification-codes/create'
      preLoaderRoute: typeof MainAppVerificationCodesCreateLazyImport
      parentRoute: typeof MainAppVerificationCodesLazyImport
    }
    '/_main/app/api-token/': {
      id: '/_main/app/api-token/'
      path: '/'
      fullPath: '/app/api-token/'
      preLoaderRoute: typeof MainAppApiTokenIndexImport
      parentRoute: typeof MainAppApiTokenLazyImport
    }
    '/_main/app/audiologists/': {
      id: '/_main/app/audiologists/'
      path: '/'
      fullPath: '/app/audiologists/'
      preLoaderRoute: typeof MainAppAudiologistsIndexImport
      parentRoute: typeof MainAppAudiologistsLazyImport
    }
    '/_main/app/catalogs/': {
      id: '/_main/app/catalogs/'
      path: '/'
      fullPath: '/app/catalogs/'
      preLoaderRoute: typeof MainAppCatalogsIndexImport
      parentRoute: typeof MainAppCatalogsLazyImport
    }
    '/_main/app/messages/': {
      id: '/_main/app/messages/'
      path: '/'
      fullPath: '/app/messages/'
      preLoaderRoute: typeof MainAppMessagesIndexImport
      parentRoute: typeof MainAppMessagesLazyImport
    }
    '/_main/app/pos/': {
      id: '/_main/app/pos/'
      path: '/'
      fullPath: '/app/pos/'
      preLoaderRoute: typeof MainAppPosIndexImport
      parentRoute: typeof MainAppPosLazyImport
    }
    '/_main/app/users/': {
      id: '/_main/app/users/'
      path: '/'
      fullPath: '/app/users/'
      preLoaderRoute: typeof MainAppUsersIndexImport
      parentRoute: typeof MainAppUsersLazyImport
    }
    '/_main/app/verification-codes/': {
      id: '/_main/app/verification-codes/'
      path: '/'
      fullPath: '/app/verification-codes/'
      preLoaderRoute: typeof MainAppVerificationCodesIndexImport
      parentRoute: typeof MainAppVerificationCodesLazyImport
    }
    '/_main/app/customers/': {
      id: '/_main/app/customers/'
      path: '/'
      fullPath: '/app/customers/'
      preLoaderRoute: typeof MainAppCustomersIndexLazyImport
      parentRoute: typeof MainAppCustomersLazyImport
    }
    '/_main/app/catalogs/catalog/$catalogId': {
      id: '/_main/app/catalogs/catalog/$catalogId'
      path: '/catalog/$catalogId'
      fullPath: '/app/catalogs/catalog/$catalogId'
      preLoaderRoute: typeof MainAppCatalogsCatalogCatalogIdLazyImport
      parentRoute: typeof MainAppCatalogsLazyImport
    }
    '/_main/app/catalogs/catalog/$catalogId/create': {
      id: '/_main/app/catalogs/catalog/$catalogId/create'
      path: '/create'
      fullPath: '/app/catalogs/catalog/$catalogId/create'
      preLoaderRoute: typeof MainAppCatalogsCatalogCatalogIdCreateLazyImport
      parentRoute: typeof MainAppCatalogsCatalogCatalogIdLazyImport
    }
    '/_main/app/catalogs/catalog/$catalogId/rules': {
      id: '/_main/app/catalogs/catalog/$catalogId/rules'
      path: '/rules'
      fullPath: '/app/catalogs/catalog/$catalogId/rules'
      preLoaderRoute: typeof MainAppCatalogsCatalogCatalogIdRulesLazyImport
      parentRoute: typeof MainAppCatalogsCatalogCatalogIdLazyImport
    }
    '/_main/app/catalogs/catalog/$catalogId/version': {
      id: '/_main/app/catalogs/catalog/$catalogId/version'
      path: '/version'
      fullPath: '/app/catalogs/catalog/$catalogId/version'
      preLoaderRoute: typeof MainAppCatalogsCatalogCatalogIdVersionLazyImport
      parentRoute: typeof MainAppCatalogsCatalogCatalogIdLazyImport
    }
    '/_main/app/catalogs/catalog/$catalogId/': {
      id: '/_main/app/catalogs/catalog/$catalogId/'
      path: '/'
      fullPath: '/app/catalogs/catalog/$catalogId/'
      preLoaderRoute: typeof MainAppCatalogsCatalogCatalogIdIndexImport
      parentRoute: typeof MainAppCatalogsCatalogCatalogIdLazyImport
    }
    '/_main/app/catalogs/catalog/$catalogId/version/$catalogVersionId': {
      id: '/_main/app/catalogs/catalog/$catalogId/version/$catalogVersionId'
      path: '/$catalogVersionId'
      fullPath: '/app/catalogs/catalog/$catalogId/version/$catalogVersionId'
      preLoaderRoute: typeof MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyImport
      parentRoute: typeof MainAppCatalogsCatalogCatalogIdVersionLazyImport
    }
  }
}

// Create and export the route tree

interface DocsRouteChildren {
  DocsDocsIndexLazyRoute: typeof DocsDocsIndexLazyRoute
  DocsDocsApiMockLazyRoute: typeof DocsDocsApiMockLazyRoute
  DocsDocsApiMockChangelogLazyRoute: typeof DocsDocsApiMockChangelogLazyRoute
  DocsDocsApiPublicLazyRoute: typeof DocsDocsApiPublicLazyRoute
  DocsDocsApiPublicChangelogLazyRoute: typeof DocsDocsApiPublicChangelogLazyRoute
}

const DocsRouteChildren: DocsRouteChildren = {
  DocsDocsIndexLazyRoute: DocsDocsIndexLazyRoute,
  DocsDocsApiMockLazyRoute: DocsDocsApiMockLazyRoute,
  DocsDocsApiMockChangelogLazyRoute: DocsDocsApiMockChangelogLazyRoute,
  DocsDocsApiPublicLazyRoute: DocsDocsApiPublicLazyRoute,
  DocsDocsApiPublicChangelogLazyRoute: DocsDocsApiPublicChangelogLazyRoute,
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

interface MainAppApiTokenLazyRouteChildren {
  MainAppApiTokenCreateLazyRoute: typeof MainAppApiTokenCreateLazyRoute
  MainAppApiTokenIndexRoute: typeof MainAppApiTokenIndexRoute
}

const MainAppApiTokenLazyRouteChildren: MainAppApiTokenLazyRouteChildren = {
  MainAppApiTokenCreateLazyRoute: MainAppApiTokenCreateLazyRoute,
  MainAppApiTokenIndexRoute: MainAppApiTokenIndexRoute,
}

const MainAppApiTokenLazyRouteWithChildren =
  MainAppApiTokenLazyRoute._addFileChildren(MainAppApiTokenLazyRouteChildren)

interface MainAppAudiologistsLazyRouteChildren {
  MainAppAudiologistsAudiologistIdLazyRoute: typeof MainAppAudiologistsAudiologistIdLazyRoute
  MainAppAudiologistsIndexRoute: typeof MainAppAudiologistsIndexRoute
}

const MainAppAudiologistsLazyRouteChildren: MainAppAudiologistsLazyRouteChildren =
  {
    MainAppAudiologistsAudiologistIdLazyRoute:
      MainAppAudiologistsAudiologistIdLazyRoute,
    MainAppAudiologistsIndexRoute: MainAppAudiologistsIndexRoute,
  }

const MainAppAudiologistsLazyRouteWithChildren =
  MainAppAudiologistsLazyRoute._addFileChildren(
    MainAppAudiologistsLazyRouteChildren,
  )

interface MainAppCatalogsCatalogCatalogIdVersionLazyRouteChildren {
  MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute: typeof MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute
}

const MainAppCatalogsCatalogCatalogIdVersionLazyRouteChildren: MainAppCatalogsCatalogCatalogIdVersionLazyRouteChildren =
  {
    MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute:
      MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute,
  }

const MainAppCatalogsCatalogCatalogIdVersionLazyRouteWithChildren =
  MainAppCatalogsCatalogCatalogIdVersionLazyRoute._addFileChildren(
    MainAppCatalogsCatalogCatalogIdVersionLazyRouteChildren,
  )

interface MainAppCatalogsCatalogCatalogIdLazyRouteChildren {
  MainAppCatalogsCatalogCatalogIdCreateLazyRoute: typeof MainAppCatalogsCatalogCatalogIdCreateLazyRoute
  MainAppCatalogsCatalogCatalogIdRulesLazyRoute: typeof MainAppCatalogsCatalogCatalogIdRulesLazyRoute
  MainAppCatalogsCatalogCatalogIdVersionLazyRoute: typeof MainAppCatalogsCatalogCatalogIdVersionLazyRouteWithChildren
  MainAppCatalogsCatalogCatalogIdIndexRoute: typeof MainAppCatalogsCatalogCatalogIdIndexRoute
}

const MainAppCatalogsCatalogCatalogIdLazyRouteChildren: MainAppCatalogsCatalogCatalogIdLazyRouteChildren =
  {
    MainAppCatalogsCatalogCatalogIdCreateLazyRoute:
      MainAppCatalogsCatalogCatalogIdCreateLazyRoute,
    MainAppCatalogsCatalogCatalogIdRulesLazyRoute:
      MainAppCatalogsCatalogCatalogIdRulesLazyRoute,
    MainAppCatalogsCatalogCatalogIdVersionLazyRoute:
      MainAppCatalogsCatalogCatalogIdVersionLazyRouteWithChildren,
    MainAppCatalogsCatalogCatalogIdIndexRoute:
      MainAppCatalogsCatalogCatalogIdIndexRoute,
  }

const MainAppCatalogsCatalogCatalogIdLazyRouteWithChildren =
  MainAppCatalogsCatalogCatalogIdLazyRoute._addFileChildren(
    MainAppCatalogsCatalogCatalogIdLazyRouteChildren,
  )

interface MainAppCatalogsLazyRouteChildren {
  MainAppCatalogsCreateRoute: typeof MainAppCatalogsCreateRoute
  MainAppCatalogsIndexRoute: typeof MainAppCatalogsIndexRoute
  MainAppCatalogsCatalogCatalogIdLazyRoute: typeof MainAppCatalogsCatalogCatalogIdLazyRouteWithChildren
}

const MainAppCatalogsLazyRouteChildren: MainAppCatalogsLazyRouteChildren = {
  MainAppCatalogsCreateRoute: MainAppCatalogsCreateRoute,
  MainAppCatalogsIndexRoute: MainAppCatalogsIndexRoute,
  MainAppCatalogsCatalogCatalogIdLazyRoute:
    MainAppCatalogsCatalogCatalogIdLazyRouteWithChildren,
}

const MainAppCatalogsLazyRouteWithChildren =
  MainAppCatalogsLazyRoute._addFileChildren(MainAppCatalogsLazyRouteChildren)

interface MainAppCustomersLazyRouteChildren {
  MainAppCustomersIndexLazyRoute: typeof MainAppCustomersIndexLazyRoute
}

const MainAppCustomersLazyRouteChildren: MainAppCustomersLazyRouteChildren = {
  MainAppCustomersIndexLazyRoute: MainAppCustomersIndexLazyRoute,
}

const MainAppCustomersLazyRouteWithChildren =
  MainAppCustomersLazyRoute._addFileChildren(MainAppCustomersLazyRouteChildren)

interface MainAppMessagesLazyRouteChildren {
  MainAppMessagesMessageIdLazyRoute: typeof MainAppMessagesMessageIdLazyRoute
  MainAppMessagesIndexRoute: typeof MainAppMessagesIndexRoute
}

const MainAppMessagesLazyRouteChildren: MainAppMessagesLazyRouteChildren = {
  MainAppMessagesMessageIdLazyRoute: MainAppMessagesMessageIdLazyRoute,
  MainAppMessagesIndexRoute: MainAppMessagesIndexRoute,
}

const MainAppMessagesLazyRouteWithChildren =
  MainAppMessagesLazyRoute._addFileChildren(MainAppMessagesLazyRouteChildren)

interface MainAppPosLazyRouteChildren {
  MainAppPosPosIdLazyRoute: typeof MainAppPosPosIdLazyRoute
  MainAppPosCreateLazyRoute: typeof MainAppPosCreateLazyRoute
  MainAppPosIndexRoute: typeof MainAppPosIndexRoute
}

const MainAppPosLazyRouteChildren: MainAppPosLazyRouteChildren = {
  MainAppPosPosIdLazyRoute: MainAppPosPosIdLazyRoute,
  MainAppPosCreateLazyRoute: MainAppPosCreateLazyRoute,
  MainAppPosIndexRoute: MainAppPosIndexRoute,
}

const MainAppPosLazyRouteWithChildren = MainAppPosLazyRoute._addFileChildren(
  MainAppPosLazyRouteChildren,
)

interface MainAppUsersLazyRouteChildren {
  MainAppUsersUserIdLazyRoute: typeof MainAppUsersUserIdLazyRoute
  MainAppUsersCreateLazyRoute: typeof MainAppUsersCreateLazyRoute
  MainAppUsersIndexRoute: typeof MainAppUsersIndexRoute
}

const MainAppUsersLazyRouteChildren: MainAppUsersLazyRouteChildren = {
  MainAppUsersUserIdLazyRoute: MainAppUsersUserIdLazyRoute,
  MainAppUsersCreateLazyRoute: MainAppUsersCreateLazyRoute,
  MainAppUsersIndexRoute: MainAppUsersIndexRoute,
}

const MainAppUsersLazyRouteWithChildren =
  MainAppUsersLazyRoute._addFileChildren(MainAppUsersLazyRouteChildren)

interface MainAppVerificationCodesLazyRouteChildren {
  MainAppVerificationCodesVerificationCodeIdLazyRoute: typeof MainAppVerificationCodesVerificationCodeIdLazyRoute
  MainAppVerificationCodesCreateLazyRoute: typeof MainAppVerificationCodesCreateLazyRoute
  MainAppVerificationCodesIndexRoute: typeof MainAppVerificationCodesIndexRoute
}

const MainAppVerificationCodesLazyRouteChildren: MainAppVerificationCodesLazyRouteChildren =
  {
    MainAppVerificationCodesVerificationCodeIdLazyRoute:
      MainAppVerificationCodesVerificationCodeIdLazyRoute,
    MainAppVerificationCodesCreateLazyRoute:
      MainAppVerificationCodesCreateLazyRoute,
    MainAppVerificationCodesIndexRoute: MainAppVerificationCodesIndexRoute,
  }

const MainAppVerificationCodesLazyRouteWithChildren =
  MainAppVerificationCodesLazyRoute._addFileChildren(
    MainAppVerificationCodesLazyRouteChildren,
  )

interface MainRouteChildren {
  MainAppApiTokenLazyRoute: typeof MainAppApiTokenLazyRouteWithChildren
  MainAppAudiologistsLazyRoute: typeof MainAppAudiologistsLazyRouteWithChildren
  MainAppCatalogsLazyRoute: typeof MainAppCatalogsLazyRouteWithChildren
  MainAppCustomersLazyRoute: typeof MainAppCustomersLazyRouteWithChildren
  MainAppDashboardLazyRoute: typeof MainAppDashboardLazyRoute
  MainAppMessagesLazyRoute: typeof MainAppMessagesLazyRouteWithChildren
  MainAppPosLazyRoute: typeof MainAppPosLazyRouteWithChildren
  MainAppSettingsLazyRoute: typeof MainAppSettingsLazyRoute
  MainAppUsersLazyRoute: typeof MainAppUsersLazyRouteWithChildren
  MainAppVerificationCodesLazyRoute: typeof MainAppVerificationCodesLazyRouteWithChildren
  MainAppIndexRoute: typeof MainAppIndexRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainAppApiTokenLazyRoute: MainAppApiTokenLazyRouteWithChildren,
  MainAppAudiologistsLazyRoute: MainAppAudiologistsLazyRouteWithChildren,
  MainAppCatalogsLazyRoute: MainAppCatalogsLazyRouteWithChildren,
  MainAppCustomersLazyRoute: MainAppCustomersLazyRouteWithChildren,
  MainAppDashboardLazyRoute: MainAppDashboardLazyRoute,
  MainAppMessagesLazyRoute: MainAppMessagesLazyRouteWithChildren,
  MainAppPosLazyRoute: MainAppPosLazyRouteWithChildren,
  MainAppSettingsLazyRoute: MainAppSettingsLazyRoute,
  MainAppUsersLazyRoute: MainAppUsersLazyRouteWithChildren,
  MainAppVerificationCodesLazyRoute:
    MainAppVerificationCodesLazyRouteWithChildren,
  MainAppIndexRoute: MainAppIndexRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

interface ProfileRouteChildren {
  ProfileProfileUpdateEmailRoute: typeof ProfileProfileUpdateEmailRoute
  ProfileProfileUpdatePasswordRoute: typeof ProfileProfileUpdatePasswordRoute
  ProfileProfileUpdateUsernameRoute: typeof ProfileProfileUpdateUsernameRoute
  ProfileProfileDetailsLazyRoute: typeof ProfileProfileDetailsLazyRoute
  ProfileProfileIndexLazyRoute: typeof ProfileProfileIndexLazyRoute
}

const ProfileRouteChildren: ProfileRouteChildren = {
  ProfileProfileUpdateEmailRoute: ProfileProfileUpdateEmailRoute,
  ProfileProfileUpdatePasswordRoute: ProfileProfileUpdatePasswordRoute,
  ProfileProfileUpdateUsernameRoute: ProfileProfileUpdateUsernameRoute,
  ProfileProfileDetailsLazyRoute: ProfileProfileDetailsLazyRoute,
  ProfileProfileIndexLazyRoute: ProfileProfileIndexLazyRoute,
}

const ProfileRouteWithChildren =
  ProfileRoute._addFileChildren(ProfileRouteChildren)

interface PublicRouteChildren {
  PublicHomeRoute: typeof PublicHomeRoute
  PublicDataProtectionLazyRoute: typeof PublicDataProtectionLazyRoute
  PublicImprintLazyRoute: typeof PublicImprintLazyRoute
  PublicRegistrationLazyRoute: typeof PublicRegistrationLazyRoute
  PublicRegistrationSuccessLazyRoute: typeof PublicRegistrationSuccessLazyRoute
  PublicTermsOfServiceLazyRoute: typeof PublicTermsOfServiceLazyRoute
  PublicTermsOfService2026LazyRoute: typeof PublicTermsOfService2026LazyRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicHomeRoute: PublicHomeRoute,
  PublicDataProtectionLazyRoute: PublicDataProtectionLazyRoute,
  PublicImprintLazyRoute: PublicImprintLazyRoute,
  PublicRegistrationLazyRoute: PublicRegistrationLazyRoute,
  PublicRegistrationSuccessLazyRoute: PublicRegistrationSuccessLazyRoute,
  PublicTermsOfServiceLazyRoute: PublicTermsOfServiceLazyRoute,
  PublicTermsOfService2026LazyRoute: PublicTermsOfService2026LazyRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/home': typeof PublicHomeRoute
  '/data-protection': typeof PublicDataProtectionLazyRoute
  '/imprint': typeof PublicImprintLazyRoute
  '/registration': typeof PublicRegistrationLazyRoute
  '/registration-success': typeof PublicRegistrationSuccessLazyRoute
  '/terms-of-service': typeof PublicTermsOfServiceLazyRoute
  '/terms-of-service2026': typeof PublicTermsOfService2026LazyRoute
  '/profile/update-email': typeof ProfileProfileUpdateEmailRoute
  '/profile/update-password': typeof ProfileProfileUpdatePasswordRoute
  '/profile/update-username': typeof ProfileProfileUpdateUsernameRoute
  '/app/api-token': typeof MainAppApiTokenLazyRouteWithChildren
  '/app/audiologists': typeof MainAppAudiologistsLazyRouteWithChildren
  '/app/catalogs': typeof MainAppCatalogsLazyRouteWithChildren
  '/app/customers': typeof MainAppCustomersLazyRouteWithChildren
  '/app/dashboard': typeof MainAppDashboardLazyRoute
  '/app/messages': typeof MainAppMessagesLazyRouteWithChildren
  '/app/pos': typeof MainAppPosLazyRouteWithChildren
  '/app/settings': typeof MainAppSettingsLazyRoute
  '/app/users': typeof MainAppUsersLazyRouteWithChildren
  '/app/verification-codes': typeof MainAppVerificationCodesLazyRouteWithChildren
  '/profile/details': typeof ProfileProfileDetailsLazyRoute
  '/app': typeof MainAppIndexRoute
  '/docs': typeof DocsDocsIndexLazyRoute
  '/profile': typeof ProfileProfileIndexLazyRoute
  '/app/catalogs/create': typeof MainAppCatalogsCreateRoute
  '/docs/api/mock': typeof DocsDocsApiMockLazyRoute
  '/docs/api/mock-changelog': typeof DocsDocsApiMockChangelogLazyRoute
  '/docs/api/public': typeof DocsDocsApiPublicLazyRoute
  '/docs/api/public-changelog': typeof DocsDocsApiPublicChangelogLazyRoute
  '/app/api-token/create': typeof MainAppApiTokenCreateLazyRoute
  '/app/audiologists/$audiologistId': typeof MainAppAudiologistsAudiologistIdLazyRoute
  '/app/messages/$messageId': typeof MainAppMessagesMessageIdLazyRoute
  '/app/pos/$posId': typeof MainAppPosPosIdLazyRoute
  '/app/pos/create': typeof MainAppPosCreateLazyRoute
  '/app/users/$userId': typeof MainAppUsersUserIdLazyRoute
  '/app/users/create': typeof MainAppUsersCreateLazyRoute
  '/app/verification-codes/$verificationCodeId': typeof MainAppVerificationCodesVerificationCodeIdLazyRoute
  '/app/verification-codes/create': typeof MainAppVerificationCodesCreateLazyRoute
  '/app/api-token/': typeof MainAppApiTokenIndexRoute
  '/app/audiologists/': typeof MainAppAudiologistsIndexRoute
  '/app/catalogs/': typeof MainAppCatalogsIndexRoute
  '/app/messages/': typeof MainAppMessagesIndexRoute
  '/app/pos/': typeof MainAppPosIndexRoute
  '/app/users/': typeof MainAppUsersIndexRoute
  '/app/verification-codes/': typeof MainAppVerificationCodesIndexRoute
  '/app/customers/': typeof MainAppCustomersIndexLazyRoute
  '/app/catalogs/catalog/$catalogId': typeof MainAppCatalogsCatalogCatalogIdLazyRouteWithChildren
  '/app/catalogs/catalog/$catalogId/create': typeof MainAppCatalogsCatalogCatalogIdCreateLazyRoute
  '/app/catalogs/catalog/$catalogId/rules': typeof MainAppCatalogsCatalogCatalogIdRulesLazyRoute
  '/app/catalogs/catalog/$catalogId/version': typeof MainAppCatalogsCatalogCatalogIdVersionLazyRouteWithChildren
  '/app/catalogs/catalog/$catalogId/': typeof MainAppCatalogsCatalogCatalogIdIndexRoute
  '/app/catalogs/catalog/$catalogId/version/$catalogVersionId': typeof MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/home': typeof PublicHomeRoute
  '/data-protection': typeof PublicDataProtectionLazyRoute
  '/imprint': typeof PublicImprintLazyRoute
  '/registration': typeof PublicRegistrationLazyRoute
  '/registration-success': typeof PublicRegistrationSuccessLazyRoute
  '/terms-of-service': typeof PublicTermsOfServiceLazyRoute
  '/terms-of-service2026': typeof PublicTermsOfService2026LazyRoute
  '/profile/update-email': typeof ProfileProfileUpdateEmailRoute
  '/profile/update-password': typeof ProfileProfileUpdatePasswordRoute
  '/profile/update-username': typeof ProfileProfileUpdateUsernameRoute
  '/app/dashboard': typeof MainAppDashboardLazyRoute
  '/app/settings': typeof MainAppSettingsLazyRoute
  '/profile/details': typeof ProfileProfileDetailsLazyRoute
  '/app': typeof MainAppIndexRoute
  '/docs': typeof DocsDocsIndexLazyRoute
  '/profile': typeof ProfileProfileIndexLazyRoute
  '/app/catalogs/create': typeof MainAppCatalogsCreateRoute
  '/docs/api/mock': typeof DocsDocsApiMockLazyRoute
  '/docs/api/mock-changelog': typeof DocsDocsApiMockChangelogLazyRoute
  '/docs/api/public': typeof DocsDocsApiPublicLazyRoute
  '/docs/api/public-changelog': typeof DocsDocsApiPublicChangelogLazyRoute
  '/app/api-token/create': typeof MainAppApiTokenCreateLazyRoute
  '/app/audiologists/$audiologistId': typeof MainAppAudiologistsAudiologistIdLazyRoute
  '/app/messages/$messageId': typeof MainAppMessagesMessageIdLazyRoute
  '/app/pos/$posId': typeof MainAppPosPosIdLazyRoute
  '/app/pos/create': typeof MainAppPosCreateLazyRoute
  '/app/users/$userId': typeof MainAppUsersUserIdLazyRoute
  '/app/users/create': typeof MainAppUsersCreateLazyRoute
  '/app/verification-codes/$verificationCodeId': typeof MainAppVerificationCodesVerificationCodeIdLazyRoute
  '/app/verification-codes/create': typeof MainAppVerificationCodesCreateLazyRoute
  '/app/api-token': typeof MainAppApiTokenIndexRoute
  '/app/audiologists': typeof MainAppAudiologistsIndexRoute
  '/app/catalogs': typeof MainAppCatalogsIndexRoute
  '/app/messages': typeof MainAppMessagesIndexRoute
  '/app/pos': typeof MainAppPosIndexRoute
  '/app/users': typeof MainAppUsersIndexRoute
  '/app/verification-codes': typeof MainAppVerificationCodesIndexRoute
  '/app/customers': typeof MainAppCustomersIndexLazyRoute
  '/app/catalogs/catalog/$catalogId/create': typeof MainAppCatalogsCatalogCatalogIdCreateLazyRoute
  '/app/catalogs/catalog/$catalogId/rules': typeof MainAppCatalogsCatalogCatalogIdRulesLazyRoute
  '/app/catalogs/catalog/$catalogId/version': typeof MainAppCatalogsCatalogCatalogIdVersionLazyRouteWithChildren
  '/app/catalogs/catalog/$catalogId': typeof MainAppCatalogsCatalogCatalogIdIndexRoute
  '/app/catalogs/catalog/$catalogId/version/$catalogVersionId': typeof MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_docs': typeof DocsRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/_profile': typeof ProfileRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/home': typeof PublicHomeRoute
  '/_public/data-protection': typeof PublicDataProtectionLazyRoute
  '/_public/imprint': typeof PublicImprintLazyRoute
  '/_public/registration': typeof PublicRegistrationLazyRoute
  '/_public/registration-success': typeof PublicRegistrationSuccessLazyRoute
  '/_public/terms-of-service': typeof PublicTermsOfServiceLazyRoute
  '/_public/terms-of-service2026': typeof PublicTermsOfService2026LazyRoute
  '/_profile/profile/update-email': typeof ProfileProfileUpdateEmailRoute
  '/_profile/profile/update-password': typeof ProfileProfileUpdatePasswordRoute
  '/_profile/profile/update-username': typeof ProfileProfileUpdateUsernameRoute
  '/_main/app/api-token': typeof MainAppApiTokenLazyRouteWithChildren
  '/_main/app/audiologists': typeof MainAppAudiologistsLazyRouteWithChildren
  '/_main/app/catalogs': typeof MainAppCatalogsLazyRouteWithChildren
  '/_main/app/customers': typeof MainAppCustomersLazyRouteWithChildren
  '/_main/app/dashboard': typeof MainAppDashboardLazyRoute
  '/_main/app/messages': typeof MainAppMessagesLazyRouteWithChildren
  '/_main/app/pos': typeof MainAppPosLazyRouteWithChildren
  '/_main/app/settings': typeof MainAppSettingsLazyRoute
  '/_main/app/users': typeof MainAppUsersLazyRouteWithChildren
  '/_main/app/verification-codes': typeof MainAppVerificationCodesLazyRouteWithChildren
  '/_profile/profile/details': typeof ProfileProfileDetailsLazyRoute
  '/_main/app/': typeof MainAppIndexRoute
  '/_docs/docs/': typeof DocsDocsIndexLazyRoute
  '/_profile/profile/': typeof ProfileProfileIndexLazyRoute
  '/_main/app/catalogs/create': typeof MainAppCatalogsCreateRoute
  '/_docs/docs/api/mock': typeof DocsDocsApiMockLazyRoute
  '/_docs/docs/api/mock-changelog': typeof DocsDocsApiMockChangelogLazyRoute
  '/_docs/docs/api/public': typeof DocsDocsApiPublicLazyRoute
  '/_docs/docs/api/public-changelog': typeof DocsDocsApiPublicChangelogLazyRoute
  '/_main/app/api-token/create': typeof MainAppApiTokenCreateLazyRoute
  '/_main/app/audiologists/$audiologistId': typeof MainAppAudiologistsAudiologistIdLazyRoute
  '/_main/app/messages/$messageId': typeof MainAppMessagesMessageIdLazyRoute
  '/_main/app/pos/$posId': typeof MainAppPosPosIdLazyRoute
  '/_main/app/pos/create': typeof MainAppPosCreateLazyRoute
  '/_main/app/users/$userId': typeof MainAppUsersUserIdLazyRoute
  '/_main/app/users/create': typeof MainAppUsersCreateLazyRoute
  '/_main/app/verification-codes/$verificationCodeId': typeof MainAppVerificationCodesVerificationCodeIdLazyRoute
  '/_main/app/verification-codes/create': typeof MainAppVerificationCodesCreateLazyRoute
  '/_main/app/api-token/': typeof MainAppApiTokenIndexRoute
  '/_main/app/audiologists/': typeof MainAppAudiologistsIndexRoute
  '/_main/app/catalogs/': typeof MainAppCatalogsIndexRoute
  '/_main/app/messages/': typeof MainAppMessagesIndexRoute
  '/_main/app/pos/': typeof MainAppPosIndexRoute
  '/_main/app/users/': typeof MainAppUsersIndexRoute
  '/_main/app/verification-codes/': typeof MainAppVerificationCodesIndexRoute
  '/_main/app/customers/': typeof MainAppCustomersIndexLazyRoute
  '/_main/app/catalogs/catalog/$catalogId': typeof MainAppCatalogsCatalogCatalogIdLazyRouteWithChildren
  '/_main/app/catalogs/catalog/$catalogId/create': typeof MainAppCatalogsCatalogCatalogIdCreateLazyRoute
  '/_main/app/catalogs/catalog/$catalogId/rules': typeof MainAppCatalogsCatalogCatalogIdRulesLazyRoute
  '/_main/app/catalogs/catalog/$catalogId/version': typeof MainAppCatalogsCatalogCatalogIdVersionLazyRouteWithChildren
  '/_main/app/catalogs/catalog/$catalogId/': typeof MainAppCatalogsCatalogCatalogIdIndexRoute
  '/_main/app/catalogs/catalog/$catalogId/version/$catalogVersionId': typeof MainAppCatalogsCatalogCatalogIdVersionCatalogVersionIdLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/home'
    | '/data-protection'
    | '/imprint'
    | '/registration'
    | '/registration-success'
    | '/terms-of-service'
    | '/terms-of-service2026'
    | '/profile/update-email'
    | '/profile/update-password'
    | '/profile/update-username'
    | '/app/api-token'
    | '/app/audiologists'
    | '/app/catalogs'
    | '/app/customers'
    | '/app/dashboard'
    | '/app/messages'
    | '/app/pos'
    | '/app/settings'
    | '/app/users'
    | '/app/verification-codes'
    | '/profile/details'
    | '/app'
    | '/docs'
    | '/profile'
    | '/app/catalogs/create'
    | '/docs/api/mock'
    | '/docs/api/mock-changelog'
    | '/docs/api/public'
    | '/docs/api/public-changelog'
    | '/app/api-token/create'
    | '/app/audiologists/$audiologistId'
    | '/app/messages/$messageId'
    | '/app/pos/$posId'
    | '/app/pos/create'
    | '/app/users/$userId'
    | '/app/users/create'
    | '/app/verification-codes/$verificationCodeId'
    | '/app/verification-codes/create'
    | '/app/api-token/'
    | '/app/audiologists/'
    | '/app/catalogs/'
    | '/app/messages/'
    | '/app/pos/'
    | '/app/users/'
    | '/app/verification-codes/'
    | '/app/customers/'
    | '/app/catalogs/catalog/$catalogId'
    | '/app/catalogs/catalog/$catalogId/create'
    | '/app/catalogs/catalog/$catalogId/rules'
    | '/app/catalogs/catalog/$catalogId/version'
    | '/app/catalogs/catalog/$catalogId/'
    | '/app/catalogs/catalog/$catalogId/version/$catalogVersionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/home'
    | '/data-protection'
    | '/imprint'
    | '/registration'
    | '/registration-success'
    | '/terms-of-service'
    | '/terms-of-service2026'
    | '/profile/update-email'
    | '/profile/update-password'
    | '/profile/update-username'
    | '/app/dashboard'
    | '/app/settings'
    | '/profile/details'
    | '/app'
    | '/docs'
    | '/profile'
    | '/app/catalogs/create'
    | '/docs/api/mock'
    | '/docs/api/mock-changelog'
    | '/docs/api/public'
    | '/docs/api/public-changelog'
    | '/app/api-token/create'
    | '/app/audiologists/$audiologistId'
    | '/app/messages/$messageId'
    | '/app/pos/$posId'
    | '/app/pos/create'
    | '/app/users/$userId'
    | '/app/users/create'
    | '/app/verification-codes/$verificationCodeId'
    | '/app/verification-codes/create'
    | '/app/api-token'
    | '/app/audiologists'
    | '/app/catalogs'
    | '/app/messages'
    | '/app/pos'
    | '/app/users'
    | '/app/verification-codes'
    | '/app/customers'
    | '/app/catalogs/catalog/$catalogId/create'
    | '/app/catalogs/catalog/$catalogId/rules'
    | '/app/catalogs/catalog/$catalogId/version'
    | '/app/catalogs/catalog/$catalogId'
    | '/app/catalogs/catalog/$catalogId/version/$catalogVersionId'
  id:
    | '__root__'
    | '/'
    | '/_docs'
    | '/_main'
    | '/_profile'
    | '/_public'
    | '/_public/home'
    | '/_public/data-protection'
    | '/_public/imprint'
    | '/_public/registration'
    | '/_public/registration-success'
    | '/_public/terms-of-service'
    | '/_public/terms-of-service2026'
    | '/_profile/profile/update-email'
    | '/_profile/profile/update-password'
    | '/_profile/profile/update-username'
    | '/_main/app/api-token'
    | '/_main/app/audiologists'
    | '/_main/app/catalogs'
    | '/_main/app/customers'
    | '/_main/app/dashboard'
    | '/_main/app/messages'
    | '/_main/app/pos'
    | '/_main/app/settings'
    | '/_main/app/users'
    | '/_main/app/verification-codes'
    | '/_profile/profile/details'
    | '/_main/app/'
    | '/_docs/docs/'
    | '/_profile/profile/'
    | '/_main/app/catalogs/create'
    | '/_docs/docs/api/mock'
    | '/_docs/docs/api/mock-changelog'
    | '/_docs/docs/api/public'
    | '/_docs/docs/api/public-changelog'
    | '/_main/app/api-token/create'
    | '/_main/app/audiologists/$audiologistId'
    | '/_main/app/messages/$messageId'
    | '/_main/app/pos/$posId'
    | '/_main/app/pos/create'
    | '/_main/app/users/$userId'
    | '/_main/app/users/create'
    | '/_main/app/verification-codes/$verificationCodeId'
    | '/_main/app/verification-codes/create'
    | '/_main/app/api-token/'
    | '/_main/app/audiologists/'
    | '/_main/app/catalogs/'
    | '/_main/app/messages/'
    | '/_main/app/pos/'
    | '/_main/app/users/'
    | '/_main/app/verification-codes/'
    | '/_main/app/customers/'
    | '/_main/app/catalogs/catalog/$catalogId'
    | '/_main/app/catalogs/catalog/$catalogId/create'
    | '/_main/app/catalogs/catalog/$catalogId/rules'
    | '/_main/app/catalogs/catalog/$catalogId/version'
    | '/_main/app/catalogs/catalog/$catalogId/'
    | '/_main/app/catalogs/catalog/$catalogId/version/$catalogVersionId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DocsRoute: typeof DocsRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
  ProfileRoute: typeof ProfileRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DocsRoute: DocsRouteWithChildren,
  MainRoute: MainRouteWithChildren,
  ProfileRoute: ProfileRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_docs",
        "/_main",
        "/_profile",
        "/_public"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_docs": {
      "filePath": "_docs.tsx",
      "children": [
        "/_docs/docs/",
        "/_docs/docs/api/mock",
        "/_docs/docs/api/mock-changelog",
        "/_docs/docs/api/public",
        "/_docs/docs/api/public-changelog"
      ]
    },
    "/_main": {
      "filePath": "_main.tsx",
      "children": [
        "/_main/app/api-token",
        "/_main/app/audiologists",
        "/_main/app/catalogs",
        "/_main/app/customers",
        "/_main/app/dashboard",
        "/_main/app/messages",
        "/_main/app/pos",
        "/_main/app/settings",
        "/_main/app/users",
        "/_main/app/verification-codes",
        "/_main/app/"
      ]
    },
    "/_profile": {
      "filePath": "_profile.tsx",
      "children": [
        "/_profile/profile/update-email",
        "/_profile/profile/update-password",
        "/_profile/profile/update-username",
        "/_profile/profile/details",
        "/_profile/profile/"
      ]
    },
    "/_public": {
      "filePath": "_public.tsx",
      "children": [
        "/_public/home",
        "/_public/data-protection",
        "/_public/imprint",
        "/_public/registration",
        "/_public/registration-success",
        "/_public/terms-of-service",
        "/_public/terms-of-service2026"
      ]
    },
    "/_public/home": {
      "filePath": "_public/home.tsx",
      "parent": "/_public"
    },
    "/_public/data-protection": {
      "filePath": "_public/data-protection.lazy.tsx",
      "parent": "/_public"
    },
    "/_public/imprint": {
      "filePath": "_public/imprint.lazy.tsx",
      "parent": "/_public"
    },
    "/_public/registration": {
      "filePath": "_public/registration.lazy.tsx",
      "parent": "/_public"
    },
    "/_public/registration-success": {
      "filePath": "_public/registration-success.lazy.tsx",
      "parent": "/_public"
    },
    "/_public/terms-of-service": {
      "filePath": "_public/terms-of-service.lazy.tsx",
      "parent": "/_public"
    },
    "/_public/terms-of-service2026": {
      "filePath": "_public/terms-of-service2026.lazy.tsx",
      "parent": "/_public"
    },
    "/_profile/profile/update-email": {
      "filePath": "_profile/profile/update-email.tsx",
      "parent": "/_profile"
    },
    "/_profile/profile/update-password": {
      "filePath": "_profile/profile/update-password.tsx",
      "parent": "/_profile"
    },
    "/_profile/profile/update-username": {
      "filePath": "_profile/profile/update-username.tsx",
      "parent": "/_profile"
    },
    "/_main/app/api-token": {
      "filePath": "_main/app/api-token.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/api-token/create",
        "/_main/app/api-token/"
      ]
    },
    "/_main/app/audiologists": {
      "filePath": "_main/app/audiologists.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/audiologists/$audiologistId",
        "/_main/app/audiologists/"
      ]
    },
    "/_main/app/catalogs": {
      "filePath": "_main/app/catalogs.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/catalogs/create",
        "/_main/app/catalogs/",
        "/_main/app/catalogs/catalog/$catalogId"
      ]
    },
    "/_main/app/customers": {
      "filePath": "_main/app/customers.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/customers/"
      ]
    },
    "/_main/app/dashboard": {
      "filePath": "_main/app/dashboard.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/app/messages": {
      "filePath": "_main/app/messages.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/messages/$messageId",
        "/_main/app/messages/"
      ]
    },
    "/_main/app/pos": {
      "filePath": "_main/app/pos.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/pos/$posId",
        "/_main/app/pos/create",
        "/_main/app/pos/"
      ]
    },
    "/_main/app/settings": {
      "filePath": "_main/app/settings.lazy.tsx",
      "parent": "/_main"
    },
    "/_main/app/users": {
      "filePath": "_main/app/users.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/users/$userId",
        "/_main/app/users/create",
        "/_main/app/users/"
      ]
    },
    "/_main/app/verification-codes": {
      "filePath": "_main/app/verification-codes.lazy.tsx",
      "parent": "/_main",
      "children": [
        "/_main/app/verification-codes/$verificationCodeId",
        "/_main/app/verification-codes/create",
        "/_main/app/verification-codes/"
      ]
    },
    "/_profile/profile/details": {
      "filePath": "_profile/profile/details.lazy.tsx",
      "parent": "/_profile"
    },
    "/_main/app/": {
      "filePath": "_main/app/index.tsx",
      "parent": "/_main"
    },
    "/_docs/docs/": {
      "filePath": "_docs/docs/index.lazy.tsx",
      "parent": "/_docs"
    },
    "/_profile/profile/": {
      "filePath": "_profile/profile/index.lazy.tsx",
      "parent": "/_profile"
    },
    "/_main/app/catalogs/create": {
      "filePath": "_main/app/catalogs.create.tsx",
      "parent": "/_main/app/catalogs"
    },
    "/_docs/docs/api/mock": {
      "filePath": "_docs/docs/api.mock.lazy.tsx",
      "parent": "/_docs"
    },
    "/_docs/docs/api/mock-changelog": {
      "filePath": "_docs/docs/api.mock-changelog.lazy.tsx",
      "parent": "/_docs"
    },
    "/_docs/docs/api/public": {
      "filePath": "_docs/docs/api.public.lazy.tsx",
      "parent": "/_docs"
    },
    "/_docs/docs/api/public-changelog": {
      "filePath": "_docs/docs/api.public-changelog.lazy.tsx",
      "parent": "/_docs"
    },
    "/_main/app/api-token/create": {
      "filePath": "_main/app/api-token.create.lazy.tsx",
      "parent": "/_main/app/api-token"
    },
    "/_main/app/audiologists/$audiologistId": {
      "filePath": "_main/app/audiologists.$audiologistId.lazy.tsx",
      "parent": "/_main/app/audiologists"
    },
    "/_main/app/messages/$messageId": {
      "filePath": "_main/app/messages.$messageId.lazy.tsx",
      "parent": "/_main/app/messages"
    },
    "/_main/app/pos/$posId": {
      "filePath": "_main/app/pos.$posId.lazy.tsx",
      "parent": "/_main/app/pos"
    },
    "/_main/app/pos/create": {
      "filePath": "_main/app/pos.create.lazy.tsx",
      "parent": "/_main/app/pos"
    },
    "/_main/app/users/$userId": {
      "filePath": "_main/app/users.$userId.lazy.tsx",
      "parent": "/_main/app/users"
    },
    "/_main/app/users/create": {
      "filePath": "_main/app/users.create.lazy.tsx",
      "parent": "/_main/app/users"
    },
    "/_main/app/verification-codes/$verificationCodeId": {
      "filePath": "_main/app/verification-codes.$verificationCodeId.lazy.tsx",
      "parent": "/_main/app/verification-codes"
    },
    "/_main/app/verification-codes/create": {
      "filePath": "_main/app/verification-codes.create.lazy.tsx",
      "parent": "/_main/app/verification-codes"
    },
    "/_main/app/api-token/": {
      "filePath": "_main/app/api-token.index.tsx",
      "parent": "/_main/app/api-token"
    },
    "/_main/app/audiologists/": {
      "filePath": "_main/app/audiologists.index.tsx",
      "parent": "/_main/app/audiologists"
    },
    "/_main/app/catalogs/": {
      "filePath": "_main/app/catalogs.index.tsx",
      "parent": "/_main/app/catalogs"
    },
    "/_main/app/messages/": {
      "filePath": "_main/app/messages.index.tsx",
      "parent": "/_main/app/messages"
    },
    "/_main/app/pos/": {
      "filePath": "_main/app/pos.index.tsx",
      "parent": "/_main/app/pos"
    },
    "/_main/app/users/": {
      "filePath": "_main/app/users.index.tsx",
      "parent": "/_main/app/users"
    },
    "/_main/app/verification-codes/": {
      "filePath": "_main/app/verification-codes.index.tsx",
      "parent": "/_main/app/verification-codes"
    },
    "/_main/app/customers/": {
      "filePath": "_main/app/customers.index.lazy.tsx",
      "parent": "/_main/app/customers"
    },
    "/_main/app/catalogs/catalog/$catalogId": {
      "filePath": "_main/app/catalogs.catalog.$catalogId.lazy.tsx",
      "parent": "/_main/app/catalogs",
      "children": [
        "/_main/app/catalogs/catalog/$catalogId/create",
        "/_main/app/catalogs/catalog/$catalogId/rules",
        "/_main/app/catalogs/catalog/$catalogId/version",
        "/_main/app/catalogs/catalog/$catalogId/"
      ]
    },
    "/_main/app/catalogs/catalog/$catalogId/create": {
      "filePath": "_main/app/catalogs.catalog.$catalogId.create.lazy.tsx",
      "parent": "/_main/app/catalogs/catalog/$catalogId"
    },
    "/_main/app/catalogs/catalog/$catalogId/rules": {
      "filePath": "_main/app/catalogs.catalog.$catalogId.rules.lazy.tsx",
      "parent": "/_main/app/catalogs/catalog/$catalogId"
    },
    "/_main/app/catalogs/catalog/$catalogId/version": {
      "filePath": "_main/app/catalogs.catalog.$catalogId.version.lazy.tsx",
      "parent": "/_main/app/catalogs/catalog/$catalogId",
      "children": [
        "/_main/app/catalogs/catalog/$catalogId/version/$catalogVersionId"
      ]
    },
    "/_main/app/catalogs/catalog/$catalogId/": {
      "filePath": "_main/app/catalogs.catalog.$catalogId.index.tsx",
      "parent": "/_main/app/catalogs/catalog/$catalogId"
    },
    "/_main/app/catalogs/catalog/$catalogId/version/$catalogVersionId": {
      "filePath": "_main/app/catalogs.catalog.$catalogId.version.$catalogVersionId.lazy.tsx",
      "parent": "/_main/app/catalogs/catalog/$catalogId/version"
    }
  }
}
ROUTE_MANIFEST_END */
